import React from 'react';
import { Link } from 'react-router-dom';
const legalLinks = [{
  label: 'Privacy Policy',
  to: '/privacy-policy'
}, {
  label: 'Terms of Service',
  to: '/terms-and-conditions'
}, {
  label: 'Cookie Policy',
  to: '/cookie-policy'
}, {
  label: 'Do Not Sell My Info',
  to: '/do-not-sell-my-info'
}];

/**
 * Minimal footer carrying only OnlineCollegeGuide legal links and required
 * disclosures. Used on focused landing pages where the full site footer's
 * navigation would compete with the page's single call to action.
 */
export function LegalFooter() {
  const currentYear = new Date().getFullYear();
  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return <footer className="bg-white border-t border-gray-200 py-10" data-id="element-600" data-mp="2jyb0493ykvhs">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-601" data-mp="2k0xhf0gnipd7">
        <nav aria-label="Legal" data-id="element-602" data-mp="2xzdo4reikfvc">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-8" data-id="element-603" data-mp="2xwj6f7mvx95m">
            {legalLinks.map(link => <li key={link.to} data-id="element-604" data-mp="21lup3bgsn69o">
                <Link to={link.to} onClick={scrollToTop} className="text-sm text-gray-600 hover:text-gray-900 hover:underline transition-colors" data-id="element-605" data-mp="21mmjwk2kgzyw">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="text-xs text-gray-500 leading-relaxed space-y-3 max-w-4xl mx-auto text-center" data-id="element-606" data-mp="2ggiukpm724pa">
          <p data-id="element-607" data-mp="2kico8dxz28fy">
            <strong className="text-gray-700" data-id="element-608" data-mp="2pj0fn0q44rap">Advertiser Disclosure:</strong>{' '}
            OnlineCollegeGuide.com is an advertising-supported site. Featured or
            trusted partner programs and all school search, finder, or match
            results are for schools that compensate us. This compensation does
            not influence our school rankings, resource guides, or other
            editorially-independent information published on this site.
          </p>
          <p data-id="element-609" data-mp="387ot51m9nucg">
            <strong className="text-gray-700" data-id="element-610" data-mp="1951ajhpqdul8">TCPA Disclosure:</strong> By
            submitting your information on this website, you consent to be
            contacted by our educational partners regarding their programs via
            email, telephone, or text message.
          </p>
          <p className="pt-3 text-gray-400" data-id="element-611" data-mp="1hz68sm7728as">
            &copy; {currentYear} OnlineCollegeGuide. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}